import { computed, toValue } from 'vue';

import { isFeatureEnabledForWarehouse, WarehouseFeatureEnum } from '@nova/core';

/**
 * Wraps the warehouse features for a given warehouse.
 *
 * TODO: (welington) mirror `useSelectedWarehouseSettings` — move the generic feature
 * reader to satellite `useWarehouseFeatures`, keep Helios as a thin façade with
 * semantic helpers. No inheritance/merge concern (flat `warehouseFeatures`); this
 * is for API/structure parity only.
 *
 * @param {import('vue').MaybeRefOrGetter<WarehouseDetails | null | undefined>} warehouse
 */
export function useSelectedWarehouseFeatures(warehouse) {
  // TODO: (welington) remove `warehouse` param once warehouse state is truly global cross-modules.
  const warehouseRef = computed(() => toValue(warehouse) ?? null);

  /**
   * Checks if a feature is enabled for a given warehouse.
   * @param {WarehouseFeatureEnum} featureCode - The feature to check.
   * @returns {boolean} True if the feature is enabled, false otherwise.
   */
  const isFeatureEnabled = featureCode =>
    isFeatureEnabledForWarehouse(warehouseRef.value, featureCode);

  const isGateManagementFeatureEnabled = () =>
    isFeatureEnabled(WarehouseFeatureEnum.GateManagement);
  const isIdValidationFeatureEnabled = () => isFeatureEnabled(WarehouseFeatureEnum.IdValidation);
  const isSmartGateFeatureEnabled = () => isFeatureEnabled(WarehouseFeatureEnum.SmartGate);
  const isYMSFeatureEnabled = () => isFeatureEnabled(WarehouseFeatureEnum.YMS);

  return {
    isFeatureEnabled,

    isGateManagementFeatureEnabled,
    isIdValidationFeatureEnabled,
    isSmartGateFeatureEnabled,
    isYMSFeatureEnabled
  };
}

/**
 * @typedef {import('@satellite/composables/useWarehousesPresenter').WarehouseDetails} WarehouseDetails
 */
